
import ApiService from "@/core/services/api.service";


export const SET_LISTA_TF_PROTOCOLO = "setListTfProtocolos";
export const SET_LISTA_TF_PROTOCOLO_REV = "setListTfProtocolosRev";
export const SET_ROTA = "setRota"
export const SET_MESSAGE_ALERT = 'setMensagem'
export const SET_TF_PROTOCOLO = "setConta"
export const SET_LISTA_TF_PROTOCOLO_TF = "setListTfProtocolosTF";


const actions = {
    //tfprotocolos
    async create_tfprotocolo(context, value) {

        await ApiService.post('protocolos_tf', value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    async update_tfprotocolo(context, value) {

        await ApiService.put('protocolos_tf/'+value.id, value)
            .then(response => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'success',
                message: response.data
            }))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error',
                message: error.response.data
            }))
    },

    

    async listar_tfprotocolos(context) {
        await ApiService.get('protocolos_tf')
            .then(response => {
                context.commit(SET_LISTA_TF_PROTOCOLO, response.data)
            })
            .catch((error) => {
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: 'error',
                    message: error.response.data
                })
            })
    },

    

 

    set_tfprotocolo(context, item) {
        context.commit(SET_TF_PROTOCOLO, item)
    },

    async delete_tfprotocolo(context, value) {


        await ApiService.delete("tfprotocolos/" + value)
            .then((response) =>
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: "success",
                    message: response.data,
                })
            )
            .catch((error) =>
                context.commit(SET_MESSAGE_ALERT, {
                    tipo: "error",
                    message: error.response.data,
                })
            );


        context.commit(SET_LISTA_TF_PROTOCOLO, value)
        context.commit(SET_LISTA_TF_PROTOCOLO_REV, value)


    },

    set_rota(context, value) {
        context.commit(SET_ROTA, value)
    }



};
const getters = {};

const mutations = {
 
    [SET_LISTA_TF_PROTOCOLO](state, value) {
        state.lista_tfprotocolos = value;
    },
    [SET_LISTA_TF_PROTOCOLO_REV](state, value) {
        state.lista_tfprotocolos = state.lista_tfprotocolos.filter(
            (tfprotocolos) => tfprotocolos.id !== value.id
        );
    },
    [SET_TF_PROTOCOLO](state, value) {
        state.conta = value;
    },
    [SET_ROTA](state, value) {
        state.rota = value
    },
    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {

            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },


    [SET_LISTA_TF_PROTOCOLO_TF](state, value) {
        state.lista_tfprotocolos_tf = value;
    },

  


};

const state = {
    lista_tfprotocolos: [],
    lista_tfprotocolos_tf: [],

    conta: {},
    mensagem_alert: "",
    rota: "",
    calc_tfprotocolo: {}

};

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
